<ng-template [ngIf]="inserimento">
	<div class="col-xs-12 col-sm-12 coldx"  [ngStyle]="{ 'display' : ( visibleToggleAssocia ? 'block' : 'none') }">
		<h4 *ngIf="title">{{title}}</h4>
		<form class="cerca_grey">
			<div class="row">
				<p class="col-xs-12 col-sm-12">
					<label for="cerca-parc-strag-lbl">Cerca</label> <input id="cerca-parc-strag-lbl" type="text" #searchItem (keyup)="0" class="form-control"
						placeholder="Inserisci nome e cognome" />
				</p>
			</div>
		</form>
		<ng-template [ngIf]="legaliAll.length > 0">
			<ul id="controparticollapse" class="controparti">

				<ng-template ngFor let-legaleIncaricato
					[ngForOf]="legaliAll  | searchFilter : searchItem.value : 'legale.nominativo' ">

					<li class="panel">
						<div class="controparte">
							<div>
								<p class="col-xs-12 col-sm-2">
									<button class="btn btn-primary associa" (click)="associaLegale(legaleIncaricato);"
										type="submit">Associa</button>
								</p>
								<h4 class="titolo col-xs-12 col-sm-3">
									{{legaleIncaricato.legale?.nominativo}}
								</h4>
								<ng-template
									[ngIf]="legaleIncaricato.legale?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
									<p class="col-xs-12 col-sm-4 matricola">
										CF: <strong>{{legaleIncaricato.legale?.codiceFiscale}}</strong>
									</p>
								</ng-template>
								<ng-template
									[ngIf]="legaleIncaricato.legale?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
									<p class="col-xs-12 col-sm-3 matricola">
										P.IVA: <strong>{{legaleIncaricato.legale?.partitaIva}}</strong>
									</p>
								</ng-template>
								<p class="col-xs-12 col-sm-3 matricola">
									<strong>{{legaleIncaricato.categoriaLegaleIncaricato.label}}</strong>
								</p>
							</div>
						</div>
					</li>
				</ng-template>
			</ul>
		</ng-template>
		<ng-template [ngIf]="legaliAll.length == 0 && msgNoBeneficiari">
			<p>{{msgNoBeneficiari}}</p>
		</ng-template>
	</div>
</ng-template>

<ng-template [ngIf]="parcellaStragiudizialeForm">

	<div class="col-xs-12 col-sm-12 coldx"  [ngStyle]="{ 'display' : ( visibleToggleForm ? 'block' : 'none') }">
		<h4 *ngIf="title">{{title}}</h4>
		<div class="tab-content">
			<form [formGroup]="parcellaStragiudizialeForm">
				<div class="row">
					<ng-template [ngIf]="!inserimento">
						<div class="col-xs-12 col-sm-3">
							<p>
								<label for="tipo_legale_lbl">Tipo legale</label> <select id="tipo_legale_lbl" name="tipo_legale"
									class="form-control" (change)="populateLegali($event);">
									<ng-template ngFor let-categoria [ngForOf]="tipiLegale">
										<option value="{{categoria.id}}">{{categoria.label}}</option>
									</ng-template>
								</select>
							</p>
						</div>

						<div comboModInput class="col-xs-12 col-sm-3" [labelInput]="'Legale'" formControlName="legale"
							[labelOption]="'legale.nominativo'" [objectReference]="request.legale"
							(onReturn)="request.legale = $event" [optionsCombo]="legaliOptions"></div>
					</ng-template>


					<ng-template
						[ngIf]="inserimento && request.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
						<div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'"
							[labelInput]="'Cognome e nome'" [valueInput]="request.legale?.legale.nominativo"></div>
						<div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'"
							[labelInput]="'Tipo Legale'" [valueInput]="request.legale?.categoriaLegaleIncaricato.label">
						</div>
					</ng-template>

					<ng-template
						[ngIf]="inserimento && request.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
						<div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'"
							[labelInput]="'Ragione sociale'" [valueInput]="request.legale?.legale.ragioneSociale"></div>
						<div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'"
							[labelInput]="'Tipo Legale'" [valueInput]="request.legale?.categoriaLegaleIncaricato.label">
						</div>
					</ng-template>


					<div textInput class="col-xs-12 col-sm-3" [labelInput]="'Numero parcella'" formControlName="numeroParcella"
						[(ngModel)]="request.numeroParcella"></div>

					<div datePickerInput class="col-xs-12 col-sm-3" [labelInput]="'Data parcella'" formControlName="dataParcella"
						[(ngModel)]="request.dataParcella"
						[control]="parcellaStragiudizialeForm.controls['dataParcella']" [mandatory]="true"></div>

				</div>
				<hr>

				<div class="row">
					<div class="col-xs-12 col-sm-4">
						<label>Compenso</label>

						<p class="singlecheckbox inlineform radiobutton">
							<input value="isCheckedTabellare" name="tipocompensocheckmod{{inserimento}}_tabellare" id="tipo_tabellare1modmod{{inserimento}}"
								type="radio" [checked]="isCheckedTabellare" (click)="setModeTabellare()">
							<label for="tipo_tabellare1modmod{{inserimento}}">Tabellare</label>
							<input name="tipocompensocheckmod{{inserimento}}_percentuale" id="tipo_percentuale1mod{{inserimento}}"
								type="radio" [checked]="!isCheckedTabellare" (click)="setModePercentuale()">
							<label for="tipo_percentuale1mod{{inserimento}}">In percentuale</label>
						</p>
					</div>

					<div comboModInput class="col-xs-12 col-sm-4" [labelInput]="'Competenza'" formControlName="competenza"
						(change)="populateScaglioniFromCompetenza($event.target.value);" [submitPending]="!isCheckedTabellare"
						[objectReference]="request.competenza" (onReturn)="request.competenza = $event"
						[mandatory]="isCheckedTabellare" [ngModel]="request.competenza" [optionsCombo]="competenzeOptions"></div>

					<div comboModInput class="col-xs-12 col-sm-4" [labelInput]="'Scaglione'" formControlName="scaglione"
						[submitPending]="!isCheckedTabellare"
						(change)="populateFasiCompenso($event.target.value);" [objectReference]="request.scaglione"
						(onReturn)="request.scaglione = $event" [mandatory]="isCheckedTabellare"
						[optionsCombo]="scaglioniOptions"></div>

					<div [submitPending]="isCheckedTabellare" [location]="'SezioneEconomica'"
						textInputCurrency [control]="parcellaStragiudizialeForm.controls['importoPetitumRiferimento']"
						[labelInput]="'Valore'" class="col-xs-12 col-sm-4" formControlName="importoPetitumRiferimento"
						[mandatory]="!isCheckedTabellare" [(ngModel)]="request.importoPetitumRiferimento"
						(onReturn)="onChangePetitum($event);"></div>

					<div class="col-xs-12 col-sm-4" [submitPending]="isCheckedTabellare"
						[location]="'SezioneEconomica'" textInputCurrency [isNaturalNumber]="true"
						[control]="parcellaStragiudizialeForm.controls['percentualeImportoBase']"
						[labelInput]="'Percentuale'" formControlName="percentualeImportoBase" [maxValue]="100"
						[mandatory]="!isCheckedTabellare" [(ngModel)]="request.percentualeImportoBase"
						(onReturn)="onChangePercentuale($event);"></div>
				</div>
				<div parcella-stragiudiziale-quadro-tabellare-form #quadroCompensiTabellareForm
					[disableQuadro]="!isCheckedTabellare" [valorePetitum]="request.importoPetitumRiferimento"
					[valorePercentuale]="percentualeVal"  (onReturn)="refresh($event)"></div>
				<div parcella-stragiudiziale-quadro-percentuale-form #quadroCompensiPercentualeForm
					[disableQuadro]="isCheckedTabellare" [valorePetitum]="request.importoPetitumRiferimento"
					[valorePercentuale]="request.percentualeImportoBase" [importoBase]="this.request.importoBase" (onReturn)="refresh($event)"></div>
				<hr>
				<div class="container_conteggi">
					<h5>
						<strong>Spese</strong>
					</h5>
					<div textInputCurrency [control]="parcellaStragiudizialeForm.controls['spesaEsente']"
						[labelInput]="'Spese esenti art. 15 DPR 633/72'" formControlName="spesaEsente"
						[(ngModel)]="request.spesa.spesaEsente"></div>
					<div textInputCurrency [control]="parcellaStragiudizialeForm.controls['spesaTrasferta']"
						[labelInput]="'Spese di trasferta art. 27'" formControlName="spesaTrasferta"
						[(ngModel)]="request.spesa.spesaTrasferta"></div>
					<div textInputCurrency [control]="parcellaStragiudizialeForm.controls['altraSpesaImponibile']"
						[labelInput]="'Altre spese imponibli (non relative a trasferte)'"
						formControlName="altraSpesaImponibile" [(ngModel)]="request.spesa.altraSpesaImponibile"></div>
					<div textInputCurrency [control]="parcellaStragiudizialeForm.controls['percSpesaGenerale']"
						[labelInput]="'Spese generali % art. 2'" [maxValue]="20"
						[isNaturalNumber]="true" formControlName="percSpesaGenerale"
						[(ngModel)]="request.spesa.percSpesaGenerale"></div>
					<div
                        textInputCurrency [control]="parcellaStragiudizialeForm.controls['contributoUnificato']"
                        [labelInput]="'Contributo unificato'"
                        formControlName="contributoUnificato"
                        [(ngModel)]="request.contributoUnificato"></div>

                    <div textInputCurrency [labelInput]="'Maggiorazione p.d. %'" formControlName="maggiorazione" 
                        [control]="parcellaStragiudizialeForm.controls['maggiorazione']"
                        [(ngModel)]="request.maggiorazione" [maxValue]="100" [isNaturalNumber]="true">
                    </div>
				</div>

				<div class="container_conteggi">
					<h5>
						<strong>Accessori</strong>
					</h5>

					<div class="row">
						<div class="parcella_accessori col-sm-offset-2">
							<div singleCheckBoxModInput class="col-xs-2 col-sm-2" [layout]="'no-label'" [labelInput]="'IVA'" idInput="flagIva"
								formControlName="flagIva" [labelChecked]="'IVA'" [showLabel]="false" [labelNotChecked]="'IVA'"
								[objectReference]="request.flagIva" [showLabel]="true"
								(onReturn)="request.flagIva = $event"></div>

							<div comboModInput class="col-xs-10 col-sm-3" [labelInput]="'seleziona percentuale IVA'" formControlName="iva"
								[submitPending]="!request.flagIva" [mandatory]="request.flagIva"
								[labelOption]="'valore'" [objectReference]="request.iva"
								(onReturn)="request.iva = $event" [optionsCombo]="ivaOptions" [location]="'accessori'">
							</div>

							<div class="col-xs-2 col-sm-2" singleCheckBoxModInput [labelInput]="'CPA'" [layout]="'no-label'" [labelChecked]="'CPA'"
								[labelNotChecked]="'CPA'" idInput="flagCpa" formControlName="flagCpa"
								[objectReference]="request.flagCpa" [showLabel]="true"
								(onReturn)="request.flagCpa = $event"></div>

							<div comboModInput class="col-xs-10 col-sm-3" [labelInput]="'seleziona percentuale CPA'" formControlName="cpa"
								[submitPending]="!request.flagCpa" [mandatory]="request.flagCpa"
								[labelOption]="'valore'" [objectReference]="request.cpa"
								(onReturn)="request.cpa = $event" [optionsCombo]="cpaOptions" [location]="'accessori'">
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="parcella_accessori">
						<div singleCheckBoxModInput class="col-xs-12 col-sm-7 col-sm-offset-5 listcheckbox"
							[labelChecked]="'Ritenuta d\'\acconto'" [layout]="'no-label'" [labelNotChecked]="'Ritenuta d\'\acconto'"
							[labelInput]="'Ritenuta d\'\acconto'" idInput="flagRitenutaAcconto" [showLabel]="true"
							formControlName="flagRitenutaAcconto" [objectReference]="request.flagRitenutaAcconto"
							(onReturn)="request.flagRitenutaAcconto = $event"></div>
					</div>
				</div>

				<div class="row">
					<p class="col-sm-3 col-xs-6">
						<ng-template [ngIf]="inserimento">
							<button type="button" (click)="goToAssociaLegale();"
								class="btn btn-outline-secondary btn-block">Indietro</button>
						</ng-template>
						<ng-template [ngIf]="!inserimento">
							<button type="button" class="btn btn-outline-secondary btn-block"
								(click)="createForm();">Reset</button>
						</ng-template>
					</p>
					<p class="col-sm-3 col-xs-6 col-sm-offset-6">
						<button (click)="calcolaCompenso(request.legale);" type="button"
							[disabled]="!checkIvaCpa() || !parcellaStragiudizialeForm.valid"
							class="btn btn-primary btn-block">Calcola il compenso</button>
					</p>
				</div>

			</form>
		</div>
	</div>

	<div class="col-sm-12 coldx" id="pannello11"
		[ngStyle]="{ 'display' : ( visibleToggleRiepilogo ? 'block' : 'none') }">
		<h4>Riepilogo Parcella</h4>
		<div class="tab-content">
			<form (ngSubmit)="save();">

				<div *ngIf="riepilogo" parcella-stragiudiziale-riepilogo-form [parcellaStragiudiziale]="riepilogo">
				</div>
				<div class="row">
					<p class="col-sm-3 col-xs-6">
						<button type="button" class="btn btn-outline-secondary btn-block"
							(click)="goToForm();">Indietro</button>
					</p>
					<p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="'Salva'">
					</p>
				</div>
			</form>
		</div>
	</div>
</ng-template>